function initialize() {
    $('.page-consumer select[name="region"]').on('change', function (evt) {
        const region = $(this).find('option:selected').val();
        goRegions(region);
    });
}

function goRegions(region) {
    let url = '/servicos/consumidor';

    if (region) {
        url += '/' + region;
    }

    window.location = url + '#contatos';
}

initialize();
